import React from 'react';
import { Link } from 'react-router-dom';

export default function WhyIntegratedWellness() {
  return <section id="why" className="hbk-section section-dark" data-testid="why-section"><div className="max-w-5xl mx-auto px-4">
    <div>
      <p className="text-[#fca5a5] mono text-sm mb-4" data-testid="why-label">WHY INTEGRATED WELLNESS</p>
      <h2 className="section-heading text-white max-w-2xl" data-testid="why-heading">More Than Results.<br />A Plan Built From Your Data.</h2>
      <p className="text-white text-base mt-5 max-w-2xl" data-testid="why-description">Blood work is the starting point. We connect your available health information to help turn findings into a personalized wellness protocol.</p>
      <p className="text-white text-sm mt-4 max-w-2xl" data-testid="why-clinical-boundary">Team-led guidance. Licensed clinical review where applicable—not AI diagnosis.</p>
      <Link to="/order" className="btn-cta hbk-short-cta mt-6" data-testid="why-customize-cta">FIND MY PANEL</Link>
    </div>
  </div></section>;
}